var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformationTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Starting-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Starting-Components-Part-1",
    transform: "translate(-1480.000000, -4086.000000)",
    fill: "#00A3E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1497.50044,4108.75022 L1490.50131,4108.75022 C1490.17879,4108.75022 1489.91762,4108.48904 1489.91762,4108.16652 L1489.91762,4105.83348 C1489.91762,4105.51096 1490.17879,4105.24978 1490.50131,4105.24978 L1492.25066,4105.24978 L1492.25066,4100.5837 L1491.08326,4100.5837 C1490.76249,4100.5837 1490.50131,4100.32252 1490.50131,4100 L1490.50131,4097.66696 C1490.50131,4097.34443 1490.76249,4097.08326 1491.08326,4097.08326 L1495.1674,4097.08326 C1495.48992,4097.08326 1495.7511,4097.34443 1495.7511,4097.66696 L1495.7511,4105.24978 L1497.50044,4105.24978 C1497.82296,4105.24978 1498.08414,4105.51096 1498.08414,4105.83348 L1498.08414,4108.16652 C1498.08414,4108.48904 1497.82296,4108.75022 1497.50044,4108.75022 Z M1494,4095.91586 C1492.71341,4095.91586 1491.66696,4094.86941 1491.66696,4093.58282 C1491.66696,4092.29623 1492.71341,4091.24978 1494,4091.24978 C1495.28659,4091.24978 1496.33479,4092.29623 1496.33479,4093.58282 C1496.33479,4094.86941 1495.28659,4095.91586 1494,4095.91586 Z M1494,4086 C1486.26819,4086 1480,4092.26819 1480,4100 C1480,4107.73181 1486.26819,4114 1494,4114 C1501.73357,4114 1508,4107.73181 1508,4100 C1508,4092.26819 1501.73357,4086 1494,4086 Z",
    id: "icon_information"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationTooltip);
export default __webpack_public_path__ + "static/media/icon-information-tooltip.be476501baf842bcf039dc819de5ebc9.svg";
export { ForwardRef as ReactComponent };